export const UseCaseCode = {
    PACKAGE_NOT_STAGED_HENCE_REMOVED_FROM_DRIVERS_ITINERARY : "PACKAGE_NOT_STAGED_HENCE_REMOVED_FROM_DRIVERS_ITINERARY"
}


// WEBPACK FOOTER //
// ./src/util/UseCase.js